import type {
  CallStatusResourceResponseApi,
  CallStatusResourceResponseListResponseApi,
  EnumCallStatusApi as EnumCallStatusApiV1,
} from '@ingenico/api-sdk-device-management-private';

import type {
  DeviceCallResourceItemV2Api,
  EnumCallStatusApi as EnumCallStatusApiV2,
  SearchDeviceCallsV2MutationResponseApi,
} from '@ingenico/api-sdk-device-management-private-v2';

import { enumCallStatus as enumCallStatusv2 } from '@ingenico/api-sdk-device-management-private-v2';
import { toNumber, toString } from 'lodash-es';
import { dashString } from '../../../utils/dashString.util';
import { toIsoInstantOrEmptyString } from '../utils/date.utils';
import type {
  CallStatusResourceResponseApiFront,
  DeviceCallLogsResponseApiFront,
} from '../../../model/deviceCallLogs.model';

export function computeStatus(status: EnumCallStatusApiV2): EnumCallStatusApiV2 {
  switch (status) {
    case enumCallStatusv2.FAILURE:
    case enumCallStatusv2.REJECTED:
    case enumCallStatusv2.SUCCESS:
    case enumCallStatusv2.SUSPENDED: {
      return status;
    }
    default: {
      return enumCallStatusv2.SUCCESS;
    }
  }
}

export function mapDeviceCallLogsResponseApiToPaginatedDeviceCallLogsList(
  response: SearchDeviceCallsV2MutationResponseApi,
): CallStatusResourceResponseListResponseApi {
  return {
    pagination: response?.pagination,
    data: response?.data?.map<CallStatusResourceResponseApi>(
      ({
        device: { reference, serialNumber },
        metadata: { logEmitterType: application, date, duration, reason },
        status,
        id,
      }: DeviceCallResourceItemV2Api) => ({
        application,
        status: computeStatus(status) as EnumCallStatusApiV1,
        reference,
        serialNumber,
        callDateTime: date,
        callDuration: toNumber(duration ?? 0),
        callId: toString(id),
        statusSummary: dashString(toString(reason)),
      }),
    ),
  };
}

export function mapDeviceCallLogsResponseApiToPaginatedDeviceCallLogsListFront(
  response: SearchDeviceCallsV2MutationResponseApi,
): DeviceCallLogsResponseApiFront {
  return {
    pagination: response?.pagination,
    data: response?.data?.map<CallStatusResourceResponseApiFront>(
      ({
        device: { reference, serialNumber },
        metadata: { logEmitterType: application, date, duration, reason },
        status,
        id,
      }: DeviceCallResourceItemV2Api) => ({
        application,
        status: computeStatus(status) as EnumCallStatusApiV1,
        reference,
        serialNumber,
        callDateTime: toIsoInstantOrEmptyString(date),
        callDuration: toNumber(duration ?? 0),
        callId: toString(id),
        statusSummary: dashString(toString(reason)),
      }),
    ),
  };
}
